export default __webpack_public_path__ + "static/media/valley3.48547c3a.png";